// extracted by mini-css-extract-plugin
module.exports = {"publicationsItem":"styles_publicationsItem__2F179"};